import { planningAPI } from "../../axios";

export const actions = {

    // EmploymentType
    GetAllEmploymentType(context, data){
        return planningAPI.get(`EmploymentType/All`);
    },
    GetSingleEmploymentType(context, data){
        return planningAPI.get(`EmploymentType/${data}`);
    },
    UpdateEmploymentType(context, data){
        return planningAPI.put(`EmploymentType/${data.id}`, data);
    },
    DeleteEmploymentType(context, data){
        return planningAPI.delete(`EmploymentType/${data}`);
    },
    CreateEmploymentType(context, data){
        return planningAPI.post(`EmploymentType/Add`, data);
    },

}